import Sidebar from "../components/sidebar/sidebar";
import Navbar from "../components/navbar/navbar";
import { useContext } from "react";
import { AppContext } from "../Theme";
import Payasyougo from "../components/payasyougo/Payasyougo";
export default function Payasyougopage() {
	const { darkmode, toggleMode } = useContext(AppContext);
	return (
		<>
			<div className="sidebar-component">
				<Sidebar mode={darkmode} toggleMode={toggleMode} />
			</div>
			<div className="navbar-component">
				<Navbar username="Nexcare" mode={darkmode} />
			</div>
			<Payasyougo mode={darkmode} />
		</>
	);
}
